{
  "collectionLabel": "Sugestie"
}
